import React from 'react';
import { JobPostPageTab } from '../..';
import { Button } from 'reactstrap';

interface PropTypes {
  previewMode: boolean;
  setActiveTab: (tab: JobPostPageTab) => void;
  organizationId: number;
  jobPostId: number;
}

export function OverviewApplyButton(props: PropTypes) {
  const handleClick = () => {
    props.setActiveTab('application_form');
  };

  return (
    <Button
      color={'primary'}
      size={'lg'}
      type={'button'}
      disabled={props.previewMode}
      onClick={handleClick}
    >
      Apply
    </Button>
  );
}
